// Company information for Mirage Foods

export const companyInfo = {
  name: 'Mirage Fine Foods, Inc.',
  location: 'Torrance, CA',
  phone: '(213) 984-4192',
  fax: '(213) 232-9110',
  email: 'info@miragefoods.com'
};

export const aboutText = {
  tagline: 'Quality, Expertise and Reliability',

  hero: 'WELCOME TO MIRAGE DESSERTS',

  short: 'Strategically located in the densely populated, Southern California region, Mirage Fine Foods, Inc. specializes in the formulation and development of innovative desserts, cream fillings and cakes. We specialize in innovative product development and custom blends. We are comprised of a team of knowledgeable food industry professionals.',

  homepage: 'Mirage specializes in premium, customized dessert mixes designed to streamline your production kitchen and boost profitability. Our goal is to simplify your operations with quality mixes that reduce time, labor, ingredient, and refrigeration costs—while consistently delivering signature-quality desserts, bag after bag, case after case.',

  mission: 'To supply high quality, gourmet dessert bases and mixes to busy chefs, caterers and food service managers who need to serve a large number of customers quickly, efficiently and deliciously!',

  vision: 'To reliably serve the chef and caterer with quality, time-saving mixes so they can better concentrate on signature touches and presentation.',

  products: 'Mirage offers an array of essential bases and mixes for bakery and pastry applications.',

  testimonial: 'Pastry Chefs using Mirage mixes have served signature desserts to hundreds of thousands of satisfied customers. Mirage = Quality & Service.',

  superiorProducts: 'Mirage\'s Product Development Department comprises food technologists, cookbook authors, and chefs who collectively bring over fifty years of R&D experience in the food industry.',

  history: [
    'We specialize in the formulation and development of innovative desserts, creams, fillings, icings and cakes.',
    'We create and deliver proven Mirage mixes as well as custom mixes, designed to meet the needs and standards of our customer chefs and food managers.',
    'We assist our clients in the creation of delicious, yet wholesome desserts that incorporate the latest in industry standard ingredients, with a perfect track record of safety and consistency.',
    'We provide all of the advantages of fast, easy and economical preparation without sacrificing the taste and texture of traditional gourmet desserts and cakes.'
  ]
};

export const mirageDifference = {
  whoWeAre: 'Strategically located in the densely populated, Southern California region, we create delicious, highest quality desserts emphasizing flavor, texture and ease of preparation for restaurants, bakeries, and catering companies. We can help clients introduce a complete array of elite, gourmet dessert mixes from creme brulee to instant mousse, plus complete bakery mixes.',

  whatWeDo: 'We specialize in the formulation and development of innovative desserts, creams, fillings, icings and custom baked goods. Our focus is on quality, innovation, and customer service.',

  credentials: 'Benefit from 25 years of experience in food manufacturing. From concept and formulation through production to delivery, we have a proven track record of success.'
};

export const manufacturing = {
  intro: 'From our modern facility in Paramount, California, we are committed to providing only the highest quality products with consistent results.',

  plantCertification: 'Our manufacturing facility in Paramount, CA carries an SQF Level 2 plant certification and is ISO certified. Our products are recognized throughout the food industry for consistent quality, innovative packaging, and value.',

  qualityAssurance: 'We maintain a rigorous quality control process ensuring the highest standards of safety and purity. Custom mixes can be prepared meeting special needs: Organic certification, gluten-free mix, Kosher certification, etc.',

  labCertification: 'We use Food Safety Net Services (FSNS), an award-winning USDA, SSIS and ISO certified leader in food testing.',

  labCapabilities: [
    'Qualitative pathogen detection',
    'Quantitative pathogen detection',
    'Shelf-life testing',
    'Environmental monitoring',
    'Allergen testing'
  ],

  testing: 'No product leaves our facility without thorough testing by our facility QA Director and staff. No bag or carton leaves the plant unless it is perfect—our reputation demands it.',

  customProducts: [
    'Pastry Cream',
    'Crème Brulee',
    'Instant Mousse (Miragelle)',
    'Lava Cake',
    'Devil\'s Food Cake',
    'Vegan Brownie Mix',
    'Sugar-Free Crème Brulee Base',
    'Red Velvet Cake',
    'Golden Yellow Cake',
    'Crepe Mix',
    'Waffle Mix',
    'Churro Mix',
    'Cream Powder 32% Fat Mix'
  ]
};
